import { FC } from 'react';

import { ConfirmationModal } from '@/shared/components';
import { Text } from '@/shared/uikit/Text';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { BeneficiaryHaveAssetConfirmationModalProps } from '@/widgets/modals/types';

export const BeneficiaryHaveAssetConfirmationModal: FC<
  BeneficiaryHaveAssetConfirmationModalProps
> = ({ onConfirm }) => {
  const modals = useModalsStore();
  const { t } = useTranslation('features/editScenarios');

  const onOk = () => {
    onConfirm();
    modals.closeModal();
  };

  return (
    <ConfirmationModal
      destroyOnClose
      open={modals.isOpened}
      cancelText={t('familyMemberAlreadyHaveAccessModal.cancelButton')}
      onCancel={modals.closeModal}
      okText={t('familyMemberAlreadyHaveAccessModal.okButton')}
      onOk={onOk}
    >
      <Text>{t('familyMemberAlreadyHaveAccessModal.description')}</Text>
    </ConfirmationModal>
  );
};
